import styled from "styled-components";

export const ModalContainer = styled.div`
    width: 100%;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #ebebeb;
`;

export const Title = styled.h2`
    margin: 0;
    color: #101828;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
`;

export const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;

    img {
        width: 20px;
        height: 20px;
    }

    &:hover:not(:disabled) {
        background: #f5f5f5;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
`;

export const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const Label = styled.label`
    color: #344054;
    font-size: 14px;
    font-weight: 500;
`;

export const Required = styled.span`
    color: #fb2c36;
`;

export const Input = styled.input`
    height: 38px;
    padding: 0 12px;
    border: 1px solid #d6d6d6;
    border-radius: 8px;
    color: #101828;
    font-size: 14px;

    &:focus {
        outline: none;
        border-color: #700ac1;
        box-shadow: 0 0 0 2px rgba(112, 10, 193, 0.1);
    }

    &::placeholder {
        color: #99a1af;
    }

    &:disabled {
        background: #f9fafb;
        cursor: not-allowed;
    }
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 16px 20px;
    border-top: 1px solid #ebebeb;
`;

export const CancelButton = styled.button`
    min-width: 88px;
    height: 36px;
    padding: 0 16px;
    border: 1px solid #d6d6d6;
    border-radius: 8px;
    background: #ffffff;
    color: #344054;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: #f9fafb;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const CreateButton = styled.button`
    min-width: 130px;
    height: 36px;
    padding: 0 18px;
    border: 0;
    border-radius: 8px;
    background: #700ac1;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: #5f08a5;
    }

    &:disabled {
        background: #d1d5db;
        cursor: not-allowed;
    }
`;

export const ErrorMessage = styled.div`
    margin-top: 8px;
    color: #d92d20;
    font-size: 12px;
`;
